import { Component, OnInit, ChangeDetectorRef, EventEmitter, Output, Input } from '@angular/core';
import { AccountService, InstoreService } from '@app/_services';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router"
import { first } from 'rxjs/operators';
import { ToastrService, IndividualConfig } from 'ngx-toastr';
import * as moment from 'moment';
import { ConfirmDialogService } from '@app/module/confirm-dialog/confirm-dialog/confirm-dialog.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DataService } from '@app/_services';
import { Sort } from '@angular/material/sort';

@Component({
  selector: 'app-instorelist',
  templateUrl: './instorelist.component.html',
  styleUrls: ['./instorelist.component.css']
})
export class InstorelistComponent implements OnInit {
  private format = 'YYYY-MM-DD';
  @Input() startDateLabel: string;
  @Input() endDateLabel: string;
  @Input() startDateInput;
  @Input() endDateInput;
  @Output() StartEndDatesOutput = new EventEmitter();
  isLog = false;


  AssetsDataLists: any;
  CreativeDataLists: any;
  RegionDataLists: any;
  ShowroomDataLists: any;
  VendorDataLists: any;
  f_Region_Showroom_list: any;
  isLoading = false;
  isShowTab = true;
  InstoreData_Lists: any;
  showroom_InstoreLists: any;
  showroom_filtered_InstoreLists: any;
  grouped_instoreLists: any;
  FloorDataLists: any;
  f_FloorLists: any;
  f_locationLists: any;
  instoreCurrentData;
  instorePreviousData;
  form: UntypedFormGroup;
  filterform: UntypedFormGroup;
  submitted = false;
  isEdit: boolean = false;
  page = 1;
  pageSize = 8;
  selected_region_id: number;
  selected_region_name: string;
  selected_showroom_id: number;
  selected_showroom_name: string;
  d_selected_instoreID: number;
  d_selected_instoreName: string;
  nSubModule = 1; //1-StateWise 2-detail 2-Modify
  todayDate: Date = new Date();
  minDate: any;
  isAllInstoreChecked: boolean;
  instoreCheckedLists: any;
  options: IndividualConfig;
  isFromDashboard: boolean = false;
  term: string;

  nExpired0: any;
  nExpiredNot: any;
  nExpiredAll: any;

  nUnchange10: any;
  nUnchange30: any;
  nUnchange180: any;
  nUnchange720: any;
  nUnchange1825: any;
  imageSrc;
  InstoreExpiredLists: any;
  FilteredInstoreExpiredLists: any;

  selectedFloor = -1;
  selectedAssetID = [];
  selectedCreativeIds = [];
  selectedVendorIds = [];
  selectedFloorIds = [];
  user_role_id: number = 0;
  user_region_id: number = 0;
  user_showroom_id: number = 0;
  dropdownList = [];
  d_instoreData: any = [];
  dropdownSettings: IDropdownSettings;

  is_Admin_User: boolean = true;
  is_Admin_can_Edit: boolean = true;

  constructor(private formBuilder: UntypedFormBuilder,
    private cdRef: ChangeDetectorRef, private _Activatedroute: ActivatedRoute,
    private accountService: AccountService,
    private router: Router, private instoreService: InstoreService, private toastr: ToastrService, fb: UntypedFormBuilder, private confirmDialogService: ConfirmDialogService,
    private renderer: Renderer2, private dataService: DataService) {
    this.isAllInstoreChecked = false;
    this.options = this.toastr.toastrConfig;
    //this.options.positionClass = 'toast-top-center';
    this.options.timeOut = 1000;
  }
  ngOnInit(): void {

    this.isFromDashboard = false;

    var userdata = localStorage.getItem('userInformation');
    var _data = JSON.parse(userdata);
    if (_data) {
      this.user_role_id = _data.role_id;
      this.user_region_id = _data.region_id;
      this.user_showroom_id = _data.showroom_id;

      if (this.user_role_id == 1 || this.user_role_id == 2) {
        this.is_Admin_User = true
      } else {
        this.is_Admin_User = false
      }

      if (this.is_Admin_User) {
        if (_data.is_view == 1) {
          this.is_Admin_can_Edit = false;
        } else {
          this.is_Admin_can_Edit = true;
        }
      }
    }

    this.filterform = this.formBuilder.group({
      asset_type_id: [''],
      creative_id: [''],
      floor_id: [''],
      vendor_id: [''],
      search: ['']
    });

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 2,
    }

    this.form = this.formBuilder.group({
      instore_id: '',
      particulars: [''], //m
      region_id: [''], //m
      showroom_id: [''], //m
      floor_id: [''], //m
      location_id: [''], //m
      asset_type_id: [''], //m
      creative_id: [''], //m
      vendor_id: [''], //m
      name: [''], //m
      size_w: [''], //m
      size_h: [''], //m
      square_feet: [''],
      install_date: [''], //m
      expiry_date: [''], //m
      image: [''],
    });

    this.form.controls['install_date'].setValue(this.startDateInput);
    if (this.form.controls['install_date'].value) {
      if (this.endDateInput) {
        this.form.controls['expiry_date'].setValue(this.endDateInput);
        this.endDateClicked();
      }
    }



    this.reloadAssetsLists();
    this.reloadCreativeLists();
    this.reloadRegionLists();
    this.reloadShowroomLists();
    this.reloadFloorLists();
    this.reloadVendorLists()
    this.getExpiredData();
    this.d_instoreData = this.instoreService.getInstoreData();

    if (Object.keys(this.d_instoreData).length != 0) {
      this.isFromDashboard = true;
      this.nSubModule = 2;
      this.d_selected_instoreID = this.d_instoreData.id;
      this.d_selected_instoreName = this.d_instoreData.name;
      this.showInstoreData(this.d_instoreData.region_id, this.d_instoreData.regionName, this.d_instoreData.showroom_id, this.d_instoreData.showroomName);
      this.instoreService.clearInstoreData();
    } else {
      this.isFromDashboard = false;
      this.nSubModule = 1;
    }


  }
  getExpiredData() {
    this.instoreService.getInstoreExpiryAdds(this.user_region_id, this.user_showroom_id)
      .subscribe(
        (response) => {
          this.nExpired0 = response.result.expiry_0;
          this.nExpiredNot = response.result.expiry_10;
          this.nExpiredAll = response.result.expiry_1;
          this.loadExpiredData(1)
          this.isLoading = false;
        },
        (error) => {
          this.isLoading = false;
        }
      );
  }

  omit_special_char(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }


  selectFloor(floorID) {
    this.selectedFloor = floorID;
  }
  loadExpiredData(expiryDays) {
    this.page = 1;
    this.InstoreExpiredLists = [];
    if (expiryDays === 0) {
      this.InstoreExpiredLists = this.nExpired0;
    } else if (expiryDays === 10) {
      this.InstoreExpiredLists = this.nExpiredNot;
    } else {
      this.InstoreExpiredLists = this.nExpiredAll;
    }
    this.FilteredInstoreExpiredLists = this.InstoreExpiredLists;
    this.sortArray(this.FilteredInstoreExpiredLists)
    this.loadUnchangedAdsData();
  }

  onItemSelect(item: any) {
    this.selectedAssetID.push(item.id);
    if (this.nSubModule == 1) {
      this.filterTable1();
    } else if (this.nSubModule == 4) {
      this.filterInstoreModify();
    } else {
      this.filterTable2();
    }
  }

  public splitNumber(value: number): string {
    if (value != null) {
      if (value == 0) {
        return 0 + "";
      }

      return Math.round(value * 100) / 100 + "'";
      // var str = value.toString();
      // var numarray = str.split('.');
      // var a = new Array();
      // a = numarray;
      // if(a[1] ==0 || a[1] == null|| a[1] == ''|| a[1] == undefined){
      //   return a[0]+"'";
      // }else{
      //   a[1] = a[1].slice(0, 2);
      //   return a[0] +"' "+ a[1]+"\"";
      // }
    }
  }
  onSelectAll() {
    // this.selectedAssetID = this.InstoreExpiredLists.map(x => x.asset_type_id);
    this.selectedAssetID = this.AssetsDataLists.map(x => x.id);
    this.selectedAssetID = this.selectedAssetID.filter(function (elem, index, self) {
      return index === self.indexOf(elem);
    })
    if (this.nSubModule == 1) {
      this.filterTable1();
    } else if (this.nSubModule == 4) {
      this.filterInstoreModify();
    } else {
      this.filterTable2();
    }
  }
  onDeSelectAll() {
    this.selectedAssetID = [];
    if (this.nSubModule == 1) {
      this.filterTable1();
    } else if (this.nSubModule == 4) {
      this.filterInstoreModify();
    } else {
      this.filterTable2();
    }
  }
  onItemDeSelect(item: any) {
    this.selectedAssetID.forEach((value, index) => {
      if (value == item.id) this.selectedAssetID.splice(index, 1);
    });
    if (this.nSubModule == 1) {
      this.filterTable1();
    } else if (this.nSubModule == 4) {
      this.filterInstoreModify();
    } else {
      this.filterTable2();
    }
  }


  onCreativeItemSelect(item: any) {

    this.selectedCreativeIds.push(item.id);
    if (this.nSubModule == 1) {
      this.filterTable1();
    } else if (this.nSubModule == 4) {
      this.filterInstoreModify();
    } else {
      this.filterTable2();
    }
  }
  onCreativeSelectAll() {
    // this.selectedCreativeIds = this.InstoreExpiredLists.map(x => x.creative_id);
    this.selectedCreativeIds = this.CreativeDataLists.map(x => x.id);
    this.selectedCreativeIds = this.selectedCreativeIds.filter(function (elem, index, self) {
      return index === self.indexOf(elem);
    })
    if (this.nSubModule == 1) {
      this.filterTable1();
    } else if (this.nSubModule == 4) {
      this.filterInstoreModify();
    } else {
      this.filterTable2();
    }
  }
  onCreativeDeSelectAll() {
    this.selectedCreativeIds = [];
    if (this.nSubModule == 1) {
      this.filterTable1();
    } else if (this.nSubModule == 4) {
      this.filterInstoreModify();
    } else {
      this.filterTable2();
    }
  }
  onCreativeItemDeSelect(item: any) {
    this.selectedCreativeIds.forEach((value, index) => {
      if (value == item.id) this.selectedCreativeIds.splice(index, 1);
    });

    if (this.nSubModule == 1) {
      this.filterTable1();
    } else if (this.nSubModule == 4) {
      this.filterInstoreModify();
    } else {
      this.filterTable2();
    }
  }


  onVendorItemSelect(item: any) {

    this.selectedVendorIds.push(item.id);
    if (this.nSubModule == 1) {
      this.filterTable1();
    } else if (this.nSubModule == 4) {
      this.filterInstoreModify();
    } else {
      this.filterTable2();
    }
  }
  onVendorSelectAll() {
    // this.selectedVendorIds = this.InstoreExpiredLists.map(x => x.vendor_id);
    this.selectedVendorIds = this.VendorDataLists.map(x => x.id);
    this.selectedVendorIds = this.selectedVendorIds.filter(function (elem, index, self) {
      return index === self.indexOf(elem);
    })
    // this.FilteredInstoreExpiredLists = [...this.InstoreExpiredLists];
    if (this.nSubModule == 1) {
      this.filterTable1();
    } else if (this.nSubModule == 4) {
      this.filterInstoreModify();
    } else {
      this.filterTable2();
    }
  }
  onVendorDeSelectAll() {
    this.selectedVendorIds = [];
    // this.FilteredInstoreExpiredLists = [...this.InstoreExpiredLists];
    if (this.nSubModule == 1) {
      this.filterTable1();
    } else if (this.nSubModule == 4) {
      this.filterInstoreModify();
    } else {
      this.filterTable2();
    }
  }
  onVendorItemDeSelect(item: any) {
    // this.selectedCreativeIds.splice(this.selectedCreativeIds.indexOf(item.id), 1);
    this.selectedVendorIds.forEach((value, index) => {
      if (value == item.id) this.selectedVendorIds.splice(index, 1);
    });

    if (this.nSubModule == 1) {
      this.filterTable1();
    } else if (this.nSubModule == 4) {
      this.filterInstoreModify();
    } else {
      this.filterTable2();
    }
  }

  filterTable1() {
    if (this.selectedAssetID.length > 0 && this.selectedCreativeIds.length == 0 && this.selectedVendorIds.length == 0) {
      this.FilteredInstoreExpiredLists = [
        ...this.InstoreExpiredLists.filter(x => this.selectedAssetID.includes(x.asset_type_id))
      ];
    } else if (this.selectedAssetID.length == 0 && this.selectedCreativeIds.length > 0 && this.selectedVendorIds.length == 0) {
      this.FilteredInstoreExpiredLists = [
        ...this.InstoreExpiredLists.filter(x => this.selectedCreativeIds.includes(x.creative_id))
      ];
    } else if (this.selectedAssetID.length == 0 && this.selectedCreativeIds.length == 0 && this.selectedVendorIds.length > 0) {
      this.FilteredInstoreExpiredLists = [
        ...this.InstoreExpiredLists.filter(x => this.selectedVendorIds.includes(x.vendor_id))
      ];
    }


    else if (this.selectedAssetID.length > 0 && this.selectedCreativeIds.length > 0 && this.selectedVendorIds.length == 0) {
      this.FilteredInstoreExpiredLists = [
        ...this.InstoreExpiredLists.filter(x => this.selectedAssetID.includes(x.asset_type_id) && this.selectedCreativeIds.includes(x.creative_id))
      ];
    } else if (this.selectedAssetID.length > 0 && this.selectedCreativeIds.length == 0 && this.selectedVendorIds.length > 0) {
      this.FilteredInstoreExpiredLists = [
        ...this.InstoreExpiredLists.filter(x => this.selectedAssetID.includes(x.asset_type_id) && this.selectedVendorIds.includes(x.vendor_id))
      ];
    } else if (this.selectedAssetID.length == 0 && this.selectedCreativeIds.length > 0 && this.selectedVendorIds.length > 0) {
      this.FilteredInstoreExpiredLists = [
        ...this.InstoreExpiredLists.filter(x => this.selectedCreativeIds.includes(x.creative_id) && this.selectedVendorIds.includes(x.vendor_id))
      ];
    }



    else if (this.selectedAssetID.length == 0 && this.selectedCreativeIds.length == 0 && this.selectedVendorIds.length == 0) {
      this.FilteredInstoreExpiredLists = [...this.InstoreExpiredLists];
    } else {
      this.FilteredInstoreExpiredLists = [
        ...this.InstoreExpiredLists.filter(x => this.selectedAssetID.includes(x.asset_type_id) && this.selectedCreativeIds.includes(x.creative_id) && this.selectedVendorIds.includes(x.vendor_id))
      ];
    }


  }

  doSearch(input) {
    this.dataService.setSearchText(input);
  }



  onFloorItemSelect(item: any) {

    this.selectedFloorIds.push(item.id);
    this.filterTable2();

  }
  onFloorSelectAll() {
    this.selectedFloorIds = this.f_FloorLists.map(x => x.id);
    this.selectedFloorIds = this.selectedFloorIds.filter(function (elem, index, self) {
      return index === self.indexOf(elem);
    })
    this.filterTable2();

  }
  onFloorDeSelectAll() {
    this.selectedFloorIds = [];
    this.filterTable2();

  }
  onFloorItemDeSelect(item: any) {
    this.selectedFloorIds.forEach((value, index) => {
      if (value == item.id) this.selectedFloorIds.splice(index, 1);
    });


    this.filterTable2();

  }
  filterInstoreModify() {
    this.dataService.setAssetDataLists(this.selectedAssetID);
    this.dataService.setCreativeDataLists(this.selectedCreativeIds);
    this.dataService.setVendorDataLists(this.selectedVendorIds);
    this.dataService.setSearchText("");

  }
  filterTable2() {

    this.showroom_filtered_InstoreLists = [];

    if (this.selectedFloorIds.length == 0) {
      this.showroom_filtered_InstoreLists = [...this.showroom_InstoreLists];
    } else {
      this.showroom_filtered_InstoreLists = [...this.showroom_InstoreLists.filter(x => this.selectedFloorIds.includes(x.floor_id))];
    }


    if (this.selectedAssetID.length > 0 && this.selectedCreativeIds.length == 0 && this.selectedVendorIds.length == 0) {
      this.showroom_filtered_InstoreLists = [
        ...this.showroom_filtered_InstoreLists.filter(x => this.selectedAssetID.includes(x.asset_type_id))
      ];
    } else if (this.selectedAssetID.length == 0 && this.selectedCreativeIds.length > 0 && this.selectedVendorIds.length == 0) {
      this.showroom_filtered_InstoreLists = [
        ...this.showroom_filtered_InstoreLists.filter(x => this.selectedCreativeIds.includes(x.creative_id))
      ];
    } else if (this.selectedAssetID.length == 0 && this.selectedCreativeIds.length == 0 && this.selectedVendorIds.length > 0) {
      this.showroom_filtered_InstoreLists = [
        ...this.showroom_filtered_InstoreLists.filter(x => this.selectedVendorIds.includes(x.vendor_id))
      ];
    }


    else if (this.selectedAssetID.length > 0 && this.selectedCreativeIds.length > 0 && this.selectedVendorIds.length == 0) {
      this.showroom_filtered_InstoreLists = [
        ...this.showroom_filtered_InstoreLists.filter(x => this.selectedAssetID.includes(x.asset_type_id) && this.selectedCreativeIds.includes(x.creative_id))
      ];
    } else if (this.selectedAssetID.length > 0 && this.selectedCreativeIds.length == 0 && this.selectedVendorIds.length > 0) {
      this.showroom_filtered_InstoreLists = [
        ...this.showroom_filtered_InstoreLists.filter(x => this.selectedAssetID.includes(x.asset_type_id) && this.selectedVendorIds.includes(x.vendor_id))
      ];
    } else if (this.selectedAssetID.length == 0 && this.selectedCreativeIds.length > 0 && this.selectedVendorIds.length > 0) {
      this.showroom_filtered_InstoreLists = [
        ...this.showroom_filtered_InstoreLists.filter(x => this.selectedCreativeIds.includes(x.creative_id) && this.selectedVendorIds.includes(x.vendor_id))
      ];
    }



    else if (this.selectedAssetID.length == 0 && this.selectedCreativeIds.length == 0 && this.selectedVendorIds.length == 0) {
      this.showroom_filtered_InstoreLists = [...this.showroom_filtered_InstoreLists];
    }
    else {
      this.showroom_filtered_InstoreLists = [
        ...this.showroom_filtered_InstoreLists.filter(x => this.selectedAssetID.includes(x.asset_type_id) && this.selectedCreativeIds.includes(x.creative_id) && this.selectedVendorIds.includes(x.vendor_id))
      ];
    }

    console.log("---" + JSON.stringify(this.f_FloorLists));

    this.grouped_instoreLists = this.f_FloorLists.reduce((r, { id }) => {
      if (!r.some(o => o.floor_id === id)) {
        r.push({ id, instoreData: this.showroom_filtered_InstoreLists.filter(v => v.floor_id === id) });
      }
      return r;
    }, []);


    if (this.isFromDashboard) {
      this.showDetailedView(this.d_selected_instoreID, this.d_selected_instoreName);
    }


  }


  loadUnchangedAdsData() {
    this.instoreService.getInstoreUnchangedAds(this.user_region_id, this.user_showroom_id)
      .subscribe(
        (response) => {
          this.isLoading = false;

          this.nUnchange10 = "" + response.result.unchanged_10.length;
          this.nUnchange30 = "" + response.result.unchanged_30.length;
          this.nUnchange180 = "" + response.result.unchanged_180.length;
          this.nUnchange720 = "" + response.result.unchanged_720.length;
          this.nUnchange1825 = "" + response.result.unchanged_1825.length;
        },
        (error) => {
          this.isLoading = false;
        }
      );
  }
  selectedInstore_ID: number;
  imageInstore: String;
  nameInstore: string;



  onRegionClick(regionID: number, regionName: string) {
    this.isShowTab = !this.isShowTab;
    this.selected_region_id = regionID;
    this.selected_region_name = regionName;
    this.f_Region_Showroom_list = this.ShowroomDataLists.filter(s => s.region_id === regionID);
  }
  onBackClick() {
    if (this.nSubModule == 2) {
      this.clearFilters()
      this.nSubModule = 1;
    } else if (this.nSubModule == 1) {
      this.isShowTab = !this.isShowTab;
    } else if (this.nSubModule == 3) {
      this.nSubModule = 2;
    } else if (this.nSubModule == 4) {
      this.clearFilters()
      this.nSubModule = 3;
    }
  }

  /*---------- Surendiran----------*/
  /*---------- Surendiran----------*/
  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  showInstoreDetails(data: any) {
    this.isFromDashboard = true;
    this.d_selected_instoreID = data.id;
    this.d_selected_instoreName = data.name;
    this.showInstoreData(data.region_id, data.regionName, data.showroom_id, data.showroomName);
  }

  showInstoreData(regionID, regionName, showroomID, showroomName) {

    this.selected_region_id = regionID;
    this.selected_region_name = regionName;
    this.selected_showroom_id = showroomID;
    this.selected_showroom_name = showroomName;
    this.InstoreData_Lists = [];
    this.onFilterShowroomChange(showroomID);



  }


  clearFilters() {

    this.filterform.get("asset_type_id").setValue([]);
    this.filterform.get("creative_id").setValue([]);
    this.filterform.get("vendor_id").setValue([]);
    this.filterform.get("floor_id").setValue([]);
    this.filterform.get("search").setValue('');

    this.selectedAssetID = [];
    this.selectedCreativeIds = [];
    this.selectedVendorIds = [];
    this.selectedFloorIds = [];

    if (this.nSubModule == 1) {
      this.filterTable1();
    } else if (this.nSubModule == 4) {
      this.filterInstoreModify();
    } else {
      this.filterTable2();
    }
  }

  groupbyFloor() {

    this.isAllChecked();
  }

  getFloorName(id) {
    for (let i = 0; i < this.FloorDataLists.length; i++) {
      if (this.FloorDataLists[i].id === id) {
        return this.FloorDataLists[i].name;
      }
    }
  }
  getFloorCode(id) {
    for (let i = 0; i < this.FloorDataLists.length; i++) {
      if (this.FloorDataLists[i].id === id) {
        return this.FloorDataLists[i].code;
      }
    }
  }
  checkAll() {
    this.isAllChecked();
    this.instoreCheckedLists = [];
    for (let i = 0; i < this.showroom_filtered_InstoreLists.length; i++) {
      if (this.isAllInstoreChecked) {
        this.showroom_filtered_InstoreLists[i].isChecked = false;
      } else {
        this.showroom_filtered_InstoreLists[i].isChecked = true;
        this.instoreCheckedLists.push(this.showroom_filtered_InstoreLists[i]);
      }
    }

    this.groupbyFloor();
  }
  setChecked(id: number) {
    this.instoreCheckedLists = [];
    for (let i = 0; i < this.showroom_filtered_InstoreLists.length; i++) {
      if (this.showroom_filtered_InstoreLists[i].id === id) {
        if (this.showroom_filtered_InstoreLists[i].isChecked) {
          this.showroom_filtered_InstoreLists[i].isChecked = false;
          this.instoreCheckedLists = [];
        } else {
          this.showroom_filtered_InstoreLists[i].isChecked = true;
          this.instoreCheckedLists.push(this.showroom_filtered_InstoreLists[i]);
        }
      }
    }
    this.getCheckedItemList();
  }

  isAllChecked() {
    this.isAllInstoreChecked = this.showroom_InstoreLists.every(function (item: any) {
      return item.isChecked == true;
    })
  }
  getCheckedItemList() {
    this.instoreCheckedLists = [];
    for (var i = 0; i < this.showroom_filtered_InstoreLists.length; i++) {
      if (this.showroom_filtered_InstoreLists[i].isChecked)
        this.instoreCheckedLists.push(this.showroom_filtered_InstoreLists[i]);
    }
    this.isAllChecked();
  }

  cancelEditInstore() {
    this.isEdit = false;
  }
  bulkUpdateModify(isUpdateorModify) {

    localStorage.setItem('lists', JSON.stringify(this.instoreCheckedLists));
    this.instoreService.setIsUpdateorModify(isUpdateorModify);
    this.instoreService.setRegionID(this.selected_region_id);
    this.instoreService.setShowRoomID(this.selected_showroom_id);
    this.clearFilters();


    this.dataService.setAssetDataLists(this.selectedAssetID);
    this.dataService.setCreativeDataLists(this.selectedCreativeIds);
    this.dataService.setVendorDataLists(this.selectedVendorIds);
    this.dataService.setSearchText("");


    this.nSubModule = 4;
  }
  editInstore() {
    this.isEdit = true;
    if (this.isEdit) {

      this.form.controls.name.setValue(this.instoreCurrentData.name);
      this.form.controls.particulars.setValue(this.instoreCurrentData.particulars);
      this.form.controls.asset_type_id.setValue(this.instoreCurrentData.asset_type_id);
      this.form.controls.creative_id.setValue(this.instoreCurrentData.creative_id);
      this.form.controls.vendor_id.setValue(this.instoreCurrentData.vendor_id);
      this.form.controls.size_w.setValue(this.instoreCurrentData.size_w);
      this.form.controls.size_h.setValue(this.instoreCurrentData.size_h);
      this.form.controls.install_date.setValue(this.instoreCurrentData.install_date);
      this.form.controls.expiry_date.setValue(this.instoreCurrentData.expiry_date);
      this.form.controls.square_feet.setValue(this.instoreCurrentData.size_w * this.instoreCurrentData.size_h);
      this.imageSrc = "https://brandmonitoringapp.grtjewels.com/api/uploads/" + this.instoreCurrentData.image;


      this.form.controls.floor_id.setValue(this.instoreCurrentData.floor_id);
      this.onChangeFloor(this.instoreCurrentData.floor_id, false)
    }
  }
  cancelEditHoarding() {
    this.isEdit = false;
  }
  onInstoreSingleModify() {
    this.form.controls.instore_id.setValue(this.instoreCurrentData.id);

    if (this.f.install_date.value != "") {
      this.form.get("install_date").setValue(moment(this.f.install_date.value).format(this.format)); //Working
    }
    if (this.f.expiry_date.value != "") {
      this.form.get("expiry_date").setValue(moment(this.f.expiry_date.value).format(this.format)); //Working
    }
    if (this.f.floor_id.value != "" && this.f.location_id.value === "") {
      this.toastr.warning("Please select Location for the selected Floor", "Info");
      return;
    }

    if (this.f.expiry_date.value === "") {
      this.toastr.warning("Please enter the Expiry Date", "Info");
      return;
    }

    const formDataNew = new FormData();
    formDataNew.append('instore_id', this.form.value.instore_id);
    formDataNew.append('particulars', this.form.value.particulars);
    formDataNew.append('region_id', this.form.value.region_id);
    formDataNew.append('showroom_id', "" + this.selected_showroom_id);
    formDataNew.append('floor_id', this.form.value.floor_id);
    formDataNew.append('location_id', this.form.value.location_id);
    formDataNew.append('asset_type_id', this.form.value.asset_type_id);
    formDataNew.append('creative_id', this.form.value.creative_id);
    formDataNew.append('vendor_id', this.form.value.vendor_id);


    formDataNew.append('name', this.form.value.name);
    formDataNew.append('size_w', this.form.value.size_w);
    formDataNew.append('size_h', this.form.value.size_h);
    formDataNew.append('square_feet', this.form.value.square_feet);
    formDataNew.append('install_date', this.form.value.install_date);
    formDataNew.append('expiry_date', this.form.value.expiry_date);
    formDataNew.append('image', this.form.get('image').value);

    this.confirmDialogService.confirmThis('Are you sure you want to modify ?', () => {
      this.isLoading = true;
      this.instoreService.instoreSingleModify(formDataNew)
        .pipe(first())
        .subscribe(
          (response) => {
            this.isLoading = false;
            this.toastr.success("Record has been modified successfully", "Success");
            this.getInstoreData();
            this.isEdit = false;
            this.selectedInstore_ID = this.f.instore_id.value;
            this.nameInstore = this.f.name.value;
          },
          (error) => {
            this.toastr.error("Sorry, something went wrong Please try again", "Warning");
            this.isLoading = false;
          }
        );
    }, () => {

    });
  }
  discontinue() {
    this.confirmDialogService.confirmThis('Are you sure you want to discontinue ' + this.instoreCurrentData.name + ' ?', () => {
      this.isLoading = true;
      for (var i = 0; i < this.grouped_instoreLists.length; i++) {

        if (this.instoreCurrentData.floor_id == this.grouped_instoreLists[i].id) {
          let dataInstore = this.grouped_instoreLists[i].instoreData;
          for (var k = 0; k < dataInstore.length; k++) {
            if (dataInstore[k].id == this.instoreCurrentData.id) {
              dataInstore.splice(k, 1);
            }
          }
        }
      }

      this.instoreService.instoreDiscontinue(this.instoreCurrentData.id, 1)
        .pipe(first())
        .subscribe(
          (response) => {
            this.isLoading = false;
            this.toastr.success("Record has been updated successfully", "Success");
            this.nSubModule = 2;
          },
          (error) => {
            this.isLoading = false;
            this.toastr.error("Sorry, something went wrong Please try again", "Warning");
          }
        );
    },

      () => {

      });

  }

  instoreRequestEmail(type) {
    var text = type == 0 ? "damaged" : "replacement";
    this.confirmDialogService.confirmThis('Are you sure you want to send a ' + text + ' request for ' + this.instoreCurrentData.name + ' ?', () => {
      this.isLoading = true;
      this.instoreService.instoreRequestEmail(this.user_role_id, this.instoreCurrentData.id, type)
        .pipe(first())
        .subscribe(
          (response) => {
            console.log("response ---" + JSON.stringify(response));
            this.isLoading = false;
            if (response.state == "ERROR") {
              this.toastr.warning(response.message, "Warning", { timeOut: 1000 });
            } else if (response.state == "SUCCESS") {
              this.toastr.success("Mail Sent Successfully", "Success", { timeOut: 1000 });
            }
          },
          (error) => {
            this.isLoading = false;
            this.toastr.error("Sorry, something went wrong Please try again", "Warning");
          }
        );
    },

      () => {

      });

  }
  x

  onInstoreSingleUpdate() {
    this.form.controls.instore_id.setValue(this.instoreCurrentData.id);
    if (this.f.install_date.value != "") {
      this.form.get("install_date").setValue(moment(this.f.install_date.value).format(this.format)); //Working
    }
    if (this.f.expiry_date.value != "") {
      this.form.get("expiry_date").setValue(moment(this.f.expiry_date.value).format(this.format)); //Working
    }
    if (this.f.floor_id.value != "" && this.f.location_id.value === "") {
      this.toastr.warning("Please select Location for the selected Floor", "Info");
      return;
    }

    if (this.f.expiry_date.value === "") {
      this.toastr.warning("Please enter the Expiry Date", "Info");
      return;
    }

    const formDataNew = new FormData();
    formDataNew.append('instore_id', this.form.value.instore_id);
    formDataNew.append('particulars', this.form.value.particulars);
    formDataNew.append('region_id', this.form.value.region_id);
    formDataNew.append('showroom_id', "" + this.selected_showroom_id);
    formDataNew.append('floor_id', this.form.value.floor_id);
    formDataNew.append('location_id', this.form.value.location_id);
    formDataNew.append('asset_type_id', this.form.value.asset_type_id);
    formDataNew.append('creative_id', this.form.value.creative_id);
    formDataNew.append('vendor_id', this.form.value.vendor_id);


    formDataNew.append('name', this.form.value.name);
    formDataNew.append('size_w', this.form.value.size_w);
    formDataNew.append('size_h', this.form.value.size_h);
    formDataNew.append('square_feet', this.form.value.square_feet);
    formDataNew.append('install_date', this.form.value.install_date);
    formDataNew.append('expiry_date', this.form.value.expiry_date);
    formDataNew.append('image', this.form.get('image').value);

    this.confirmDialogService.confirmThis('Are you sure you want to update ?', () => {
      this.isLoading = true;
      this.instoreService.instoreSingleUpdate(formDataNew)
        .pipe(first())
        .subscribe(
          (response) => {
            this.isLoading = false;
            this.toastr.warning("Record has been updated successfully", "Success");
            this.getInstoreData();
            this.isEdit = false;
            this.selectedInstore_ID = this.f.instore_id.value;
            this.nameInstore = this.f.name.value;
          },
          (error) => {
            this.isLoading = false;
            this.toastr.warning("Sorry, something went wrong Please try again", "Warning");
          }
        );
    }, () => {

    });

  }

  getExipreName(days) {
    if (days < 0) {
      return "Expired";
    } else {
      return "Not Expired";
    }
  }
  getColor(days: number): string {
    if (0 >= days)
      return 'red';
    if (days >= 1 && days <= 10)
      return '#DA8C10';
  }
  onSubmit() {
  }
  showDetailedView(id: number, name: string) {
    this.nSubModule = 3;
    this.getCheckedItemList();
    this.selectedInstore_ID = id;
    this.nameInstore = name;
    this.getInstoreData();

  }
  clickInstore(id: number, name: string) {
    this.selectedInstore_ID = id;
    this.nameInstore = name;
    this.getInstoreData()
    this.isEdit = false;
  }
  viewModule() {
    let currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
    // this.loadInstoreData();
    // this.showInstoreData(this.selected_region_id, this.selected_region_name, this.selected_showroom_id, this.selected_showroom_name);
  }
  getInstoreData() {
    this.instoreCurrentData;
    this.instorePreviousData;
    this.instoreService.getInstoreInformation(this.selectedInstore_ID)
      .pipe(first())
      .subscribe(
        (response) => {
          this.isLoading = false;
          if (response.result.log.length > 0) {
            this.isLog = true;
          } else {
            this.isLog = false;
          }
          this.instoreCurrentData = response.result.instore[0];
          this.instorePreviousData = response.result.log[0];
        },
        (error) => {
          this.isLoading = false;
        }
      );
  }
  gotoModule(e, path) {
    this.nSubModule = 3;
  }

  reloadAssetsLists() {
    this.accountService.getAssetsLists()
      .pipe(first())
      .subscribe(
        (response) => {
          this.isLoading = false;
          this.AssetsDataLists = response.result;
        },
        (error) => {
          this.isLoading = false;
        }
      );
  }
  reloadCreativeLists() {
    this.accountService.getCreativeLists()
      .pipe(first())
      .subscribe(
        (response) => {
          this.isLoading = false;
          this.CreativeDataLists = response.result;
        },
        (error) => {
          this.isLoading = false;
        }
      );
  }
  reloadRegionLists() {
    this.accountService.getRegionsLists()
      .pipe(first())
      .subscribe(
        (response) => {
          this.isLoading = false;
          this.RegionDataLists = response.result;
        },
        (error) => {
          this.isLoading = false;
        }
      );
  }
  reloadFloorLists() {
    this.isLoading = true;
    this.accountService.getFloorLists()
      .pipe(first())
      .subscribe(
        (response) => {
          this.isLoading = false;
          this.FloorDataLists = response.result;
        },
        (error) => {
          this.isLoading = false;
        }
      );
  }
  onFilterShowroomChange(id) {
    this.isLoading = true;
    this.instoreService.getFloorLists(id)
      .pipe(first())
      .subscribe(
        (response) => {
          this.isLoading = false;
          this.f_FloorLists = response.result;

          this.instoreService.getShowroomInstoreLists(this.selected_showroom_id)
            .pipe(first())
            .subscribe(
              (response) => {
                this.InstoreData_Lists = response.result;
                if (this.InstoreData_Lists.length > 0) {

                  for (let i = 0; i < this.InstoreData_Lists.length; i++) {
                    this.InstoreData_Lists[i].isChecked = false;
                    this.InstoreData_Lists[i].isSelected = false;
                  }
                  this.showroom_InstoreLists = this.InstoreData_Lists;
                  this.nSubModule = 2;
                  this.filterTable2();

                } else {
                  this.toastr.warning("No Data Found");
                }

              }, (error) => {
                this.isLoading = false;
              }
            );





        },
        (error) => {
          this.isLoading = false;
        }
      );





  }
  reloadVendorLists() {
    this.accountService.getVendorLists()
      .pipe(first())
      .subscribe(
        (response) => {
          this.isLoading = false;
          this.VendorDataLists = response.result;
        },
        (error) => {
          this.isLoading = false;
        }
      );
  }
  onChangeFloor(floorID, isEdit) {
    this.form.patchValue({
      location_id: ''
    });
    if (isEdit) {
      let splitFloor = floorID.split(" ");
      floorID = splitFloor[1] ? splitFloor[1] : floorID
    }
    this.accountService.getFloorLocationLists(this.selected_region_id, this.selected_showroom_id, floorID)
      .pipe(first())
      .subscribe(
        (response) => {
          this.isLoading = false;
          this.f_locationLists = response.result;
          if (Number(floorID) == Number(this.instoreCurrentData.floor_id)) {
            this.form.controls.location_id.setValue(this.instoreCurrentData.location_id);
          }
        },
        (error) => {
          this.isLoading = false;
        }
      );
  }
  reloadShowroomLists() {
    this.accountService.getShowroomLists()
      .pipe(first())
      .subscribe(
        (response) => {
          this.isLoading = false;
          this.ShowroomDataLists = response.result;
        },
        (error) => {
          this.isLoading = false;
        }
      );
  }
  // loadInstoreData() {
  //   this.instoreService.getInstoreLists()
  //   .pipe(first())
  //     .subscribe(
  //     (response) => {
  //       this.showroom_InstoreLists = response.result;
  //       for (let i = 0; i < this.showroom_InstoreLists.length; i++) {
  //             this.showroom_InstoreLists[i].isChecked = false;
  //             this.showroom_InstoreLists[i].isSelected = false;
  //       } 
  //       this.filter_showroom_InstoreLists = this.showroom_InstoreLists;    
  //    },(error) => {     
  //     this.isLoading = false;                               
  //   }
  //   );
  // } 

  sortData(sort: Sort) {
    const data = this.FilteredInstoreExpiredLists.slice();
    if (!sort.active || sort.direction === '') {
      this.FilteredInstoreExpiredLists = data;
      return;
    }

    this.FilteredInstoreExpiredLists = data.sort((a, b) => {
      let isAsc = sort.direction == 'asc';
      switch (sort.active) {
        case 'expiryDays': return this.accountService.compare(a.expiryDays, b.expiryDays, isAsc);
        default: return 0;
      }
    });
  }

  sortArray(activityLists: { expiryDays: number; }[]) {
    activityLists.sort(this.compare);
  }
  compare(a, b) {
    return a.expiryDays - b.expiryDays
  }

  startDateClicked(event) {
    this.minDate = event.value;
    this.StartEndDatesOutput.emit(this.getDates());
    this.resetExpiry();
  }
  resetExpiry() {
    this.form.patchValue({
      expiry_date: ''
    });
  }

  endDateClicked() {
    if (this.form.controls['install_date'].value) {
      let eventStartTime = new Date(this.form.controls['install_date'].value);
      let eventEndTime = new Date(this.form.controls['expiry_date'].value);
      this.StartEndDatesOutput.emit(this.getDates());
    } else {
      this.form.controls['expiry_date'].setValue('');
    }
  }
  getDates() {
    let startEndDates = {
      'install_date': this.form.controls['install_date'].value,
      'expiry_date': this.form.controls['expiry_date'].value
    };
    return startEndDates;
  }

  onFileChange(event) {

    const max_size = 5242880;
    const allowed_types = ['image/png', 'image/jpeg', 'image/jpg'];


    const reader = new FileReader();
    const file: File = event.target.files[0];

    if (file.size > max_size) {
      alert("Image Size should not exceed more than 5 MB")
      return false;
    }

    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imageSrc = reader.result as string;
        /*
        this.form.patchValue({
          image: reader.result
        });
        */
        this.form.get('image').setValue(event.target.files[0]);
      };

    }
  }

}
